/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Unmute_MicInputs */

const th_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดไมโครโฟน`)
};

const en_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unmute microphone`)
};

const ja_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイクのミュートを解除`)
};

const zh_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消麦克风静音`)
};

const es_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar el micrófono`)
};

const pt_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ligar o microfone`)
};

const id_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyalakan mikrofon`)
};

const fr_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réactiver le micro`)
};

const tl_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-unmute ang mikropono`)
};

const vi_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bật micrô`)
};

const ko_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마이크 음소거 해제`)
};

const de_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stummschaltung aufheben`)
};

const ru_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить микрофон`)
};

const tr_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikrofonu aç`)
};

const it_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riattiva il microfono`)
};

const pl_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Włącz mikrofon`)
};

const uk_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увімкнути мікрофон`)
};

const hi_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`माइक चालू करें`)
};

const ar_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إلغاء كتم الميكروفون`)
};

const ms_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyahsenyap mikrofon`)
};

const bn_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মাইক চালু করুন`)
};

const zh_tw2_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消麥克風靜音`)
};

const zh_hk2_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消麥克風靜音`)
};

const ur_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مائیک چالو کریں`)
};

const fa_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`روشن کردن میکروفون`)
};

const sw_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Washa maikrofoni`)
};

const nl_meeting_unmute_mic = /** @type {(inputs: Meeting_Unmute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microfoon aanzetten`)
};

/**
* | output |
* | --- |
* | "Unmute microphone" |
*
* @param {Meeting_Unmute_MicInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_unmute_mic = /** @type {((inputs?: Meeting_Unmute_MicInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Unmute_MicInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_unmute_mic(inputs)
	if (locale === "ja") return ja_meeting_unmute_mic(inputs)
	if (locale === "zh") return zh_meeting_unmute_mic(inputs)
	if (locale === "es") return es_meeting_unmute_mic(inputs)
	if (locale === "pt") return pt_meeting_unmute_mic(inputs)
	if (locale === "id") return id_meeting_unmute_mic(inputs)
	if (locale === "fr") return fr_meeting_unmute_mic(inputs)
	if (locale === "tl") return tl_meeting_unmute_mic(inputs)
	if (locale === "vi") return vi_meeting_unmute_mic(inputs)
	if (locale === "ko") return ko_meeting_unmute_mic(inputs)
	if (locale === "de") return de_meeting_unmute_mic(inputs)
	if (locale === "ru") return ru_meeting_unmute_mic(inputs)
	if (locale === "tr") return tr_meeting_unmute_mic(inputs)
	if (locale === "it") return it_meeting_unmute_mic(inputs)
	if (locale === "pl") return pl_meeting_unmute_mic(inputs)
	if (locale === "uk") return uk_meeting_unmute_mic(inputs)
	if (locale === "hi") return hi_meeting_unmute_mic(inputs)
	if (locale === "ar") return ar_meeting_unmute_mic(inputs)
	if (locale === "ms") return ms_meeting_unmute_mic(inputs)
	if (locale === "bn") return bn_meeting_unmute_mic(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_unmute_mic(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_unmute_mic(inputs)
	if (locale === "ur") return ur_meeting_unmute_mic(inputs)
	if (locale === "fa") return fa_meeting_unmute_mic(inputs)
	if (locale === "sw") return sw_meeting_unmute_mic(inputs)
	if (locale === "nl") return nl_meeting_unmute_mic(inputs)
	return en_meeting_unmute_mic(inputs)
});